import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import HeroBanner from './components/HeroBanner';
import ServicesOverview from './components/ServicesOverview';
import WhyChooseUs from './components/WhyChooseUs';
import OrangeCountyData from './components/OrangeCountyData';
import RegulationsSection from './components/RegulationsSection';
import ConsultationForm from './components/ConsultationForm';
import ContactFooter from './components/ContactFooter';

export default function Home() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, []);

  return (
    <main className="overflow-x-hidden">
      <Navbar />
      <HeroBanner />
      <ServicesOverview />
      <WhyChooseUs />
      <OrangeCountyData />
      <RegulationsSection />
      <ConsultationForm />
      <ContactFooter />
    </main>
  );
}